import React, { FCX, ReactNode } from 'react';
import { RecoilRoot } from 'recoil';

import Layout from '../layouts';

type ContainerProps = { element: ReactNode };
type Props = ContainerProps;

const Component: FCX<Props> = ({ element }) => (
  <RecoilRoot>
    <Layout>{element}</Layout>
  </RecoilRoot>
);

const Container: FCX<ContainerProps> = (props) => <Component {...props} />;

export default Container;
